import { Component, EventEmitter, Input, OnInit, Output, OnChanges } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { getParticipationIsRequest } from '../../../../redux/reducers';
import { Observable, Subscription } from 'rxjs';
import * as AgentAction from '../../../../redux/actions/loyalty/actions-agent';
import * as CustomerAction from '../../../../redux/actions/loyalty/actions-customer';
import * as ParticipationAction from '../../../../redux/actions/loyalty/actions-participation';
import { CmsPageTypes, Customer, customerConfig } from '@uxdf/direct-shared-lib';
import { take } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocationStrategy } from '@angular/common';

@Component({
  standalone: false,
  selector: 'app-loyalty-enroll-now',
  templateUrl: './loyalty-enroll-now.component.html',
  styleUrls: ['./loyalty-enroll-now.component.scss']
})
export class LoyaltyEnrollNowComponent implements OnInit, OnChanges {
  // @loyaltyDocs: loyalty-enroll-now component
  // this component allows you to request registration from the decision maker’s in the loyalty system

  @Input() isAccountEnabled = false;
  @Input() customerConfig: Customer = null;
  @Output() viewLayout = new EventEmitter<string>();

  // localise
  readonly loyaltyAmadeusPlusMeString = $localize`:@@loyalty-enroll-now.loyaltyAmadeusPlusMe:Amadeus+Me`;
  readonly loyaltyEnrollBrandNewLoyaltyProgramString = $localize`:@@loyalty-enroll-now.loyaltyEnrollBrandNewLoyaltyProgram:
  is a brand new rewards club for YOU where you can earn points to exchange for exclusive gifts.`;
  readonly loyaltyProgramDetailsFaqSectionString = $localize`:@@loyalty-enroll-now.loyaltyProgramDetailsFaqSection:FAQ section`;
  readonly loyaltyEnrollTermsTermsLinkString = $localize`:@@loyalty-enroll-now.loyaltyEnrollTermsTermsLink:Terms of use`;
  readonly loyaltyEnrollSignInButtonString = $localize`:@@loyalty-enroll-now.loyaltyEnrollSignInButton:Login`;
  CMS;
  isRequest$: Observable<boolean>;
  enrollForm: UntypedFormGroup;
  storeCode: string;
  agencyParticipation = false;
  isDecisionMaker = false;
  validate = false;
  termsLink: string;
  private readonly customerSubscription: Subscription;

  constructor(
    private readonly store: Store<any>,
    public readonly cms: CmsPageTypes,
    private readonly modalService: NgbModal,
    private readonly location: LocationStrategy
  ) {
    this.getLoyaltyConfig();
  }

  ngOnInit() {
    this.CMS = this.cms.code;
    this.termsLink = this.location.prepareExternalUrl('/content/registration-amadeus-plus-me-agreement');
    this.enrollForm = new UntypedFormGroup({
      loyaltyAgree: new UntypedFormControl(false, Validators.requiredTrue)
    });
    window.scrollTo(0, 0);
  }

  goToLoginForm(layout) {
    this.viewLayout.emit(layout);
  }

  registerAgent(content) {
    if (this.enrollForm.invalid) {
      this.validate = true;
      return;
    }

    this.modalService
      .open(content, {
        centered: true,
        container: 'body',
        backdrop: 'static'
      })
      .result.then(
        () => {
          this.store.dispatch(new AgentAction.RegisterAgent());

          if (this.customerSubscription && !this.customerSubscription.closed) {
            this.customerSubscription.unsubscribe();
          }
        },
        () => {}
      );
  }

  requestParticipation() {
    this.store.dispatch(new ParticipationAction.RequestParticipation());
    this.store.pipe(select(getParticipationIsRequest), take(1)).subscribe(response => {
      console.warn('request response = ' + response);
    });
  }

  ngOnChanges() {
    if (this.customerConfig) {
      this.storeCode = this.customerConfig.default_store_code;
      this.isDecisionMaker = this.customerConfig.is_decision_maker;

      this.store.dispatch(new CustomerAction.GetCustomer({ storeCode: this.storeCode }));
    }
  }

  private getLoyaltyConfig() {
    this.store
      .pipe(select(customerConfig))
      .pipe(take(1))
      .subscribe(store => {
        this.agencyParticipation = store.customerConfig.loyalty_enabled_for_account;
      });
  }
}
